import { Component } from "@angular/core";

@Component({
    selector: "organization-icon",
    templateUrl: "./organization-icon.component.svg",
    standalone: true,
    host: { class: "cerrix-icon" },
})
export class OrganizationIconComponent {}
